import { Img } from "components";
import Wrapper from "../components/Wrapper";

const videoLinks = [{
    url: "https://soomuch.blob.core.windows.net/data-soomuch/DemoContent/AvatarVideos/scr-2.mp4"
}]

const STEPS = [
    { title: <>We will build website for you school</>, image: "images/soomuch-demo/ResponsiveAnimation.svg" },
    { title: <>Social <br />Hub</>, image: "images/soomuch-demo/FlowChart.svg" },
    { title: <>24/7 virtual admission counselor</>, image: "images/soomuch-demo/AMan.svg" },
    { title: <>Multilingual <br />Communication</>, image: "images/soomuch-demo/Language.svg" },
    { title: <>Parental <br /> Insights</>, image: "images/soomuch-demo/ParentInsights.svg" },
    { title: <>School Management Software</>, image: "images/soomuch-demo/SchoolManagment.svg" },
]

const HowToAchive = () => {
    return (
        <Wrapper
            textAboveTitle="Now we will explain How to"
            textAboveTitleClass="text-[2.5vh] font-manropeSB"
            title={<>Achieve Up To ₹2.5 Crore-Inspired By Best Business Practices Across The World</>}
            titleSize="text-[4.5vh]"
            // description={"Everything Done For You Automatically.No time to post? No worries!"}
            videoLinks={videoLinks}
            body={<>
                <div>
                    {/* <div className="text-center">
                        <p className={`text-[2.5vh] font-medium`}><span className="font-manropeSB">Our Mantra:</span> More Reach → More Leads → More Admissions</p>
                    </div> */}
                    <div className="grid grid-cols-6 gap-4">
                        {STEPS?.map((item, index) => {
                            return <div key={"aksdnkjasbdasjdsadtitle" + index} className="flex justify-center items-end">
                                <div className="text-center font-medium text-[2.2vh]">
                                    {item?.title}
                                </div>
                            </div>
                        })}

                        <div className="col-span-6">
                            <div className="relative grid grid-cols-6">
                                <div className="absolute w-[83%] col-span-6 top-[2.5vh] left-[13.6vh] border-2 border-t-indigo-500 border-dashed">
                                </div>
                                {STEPS?.map((item, index) => {
                                    return <div key={"aksdnkjasbdasjdsad" + index} className="z-10 flex justify-center">
                                        <div className="bg-[white] text-[2.6vh] w-fit rounded-full py-[0.5vh] px-[1.7vh] font-manropeSB text-center border-2 border-smd_golden-bell">
                                            {index + 1}
                                        </div>
                                    </div>
                                })}
                            </div>
                        </div>
                        {STEPS?.map((item, index) => {
                            return <div key={"aksdnkjasbdasjdsadimage" + index} className="flex justify-center">
                                <div>
                                    <Img src={item?.image} className="max-h-[30vh]" />
                                </div>
                                {/* <div style={{
                                    height: 13 * (index + 1) + "%"
                                }} className={`w-full bg-smdGraphGradient`}></div> */}
                            </div>
                        })}
                    </div>
                </div>
            </>}
        />
    );
}

export default HowToAchive;